import React from 'react';
import Lottie from 'react-lottie';
import errorPageAnimation from '../../assets/animations/404page.json';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const ErrorDiv = styled.section`
  position: fixed;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .img-div {
    display: flex;
    width: 40rem;
    @media (max-width: 550px) {
      width: 27rem;
    }
    @media (max-width: 350px) {
      width: 19rem;
    }
  }
  p {
    color: #fff;
    text-align: center;
    font-size: 1rem;
    a {
      color: #fff;
      border: 1px solid #fff;
      padding: 0.4rem 0.8rem;
      text-decoration: none;
    }
    @media (max-width: 350px) {
      font-size: 0.8rem;
    }
  }
`;

const ErrorPage = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: errorPageAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <ErrorDiv>
      <div className='img-div'>
        <Lottie options={defaultOptions} />
      </div>
      <p>
        <Link to='/'>Home page</Link>
      </p>
    </ErrorDiv>
  );
};

export default ErrorPage;
